import { supabase } from "@/integrations/supabase/client";

/**
 * Logs an authentication event via the log_auth_event RPC.
 * Fire-and-forget — never blocks the auth flow.
 */
export function logAuthEvent(
  userId: string | null,
  email: string,
  eventType:
    | "login_success"
    | "login_failed"
    | "logout"
    | "sso_login_success"
    | "sso_login_orphan"
    | "sso_link_created"
    | "sso_link_denied"
    | "sso_provision_attempt"
    | "sso_role_denied",
  metadata?: Record<string, unknown>
): void {
  (supabase.rpc as any)("log_auth_event", {
    p_user_id: userId ?? null,
    p_email: email,
    p_event_type: eventType,
    p_metadata: metadata ?? null,
  }).then(({ error }: any) => {
    if (error && import.meta.env.DEV) {
      console.warn("[authAudit] log_auth_event failed:", error.message);
    }
  });
}
